"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

(function () {
  var enterModule = require('react-hot-loader').enterModule;

  enterModule && enterModule(module);
})();

var _default = {
  /** Additional class(es) to add to the component. */
  className: _propTypes.default.string,

  /** A unique ID to identify the notification with. The suggested way to create this is to use <a href="https://www.npmjs.com/package/uuid#quickstart---commonjs-recommended" target="_blank">uuid</a>. */
  id: _propTypes.default.string.isRequired,

  /** The message body of the notification. */
  message: _propTypes.default.node.isRequired,

  /** Determines the characteristics of the notification. */
  type: _propTypes.default.oneOf(['info', 'success', 'error', 'warning']),

  /** Whether to display the close button. */
  showClose: _propTypes.default.bool,

  /** The time (in milliseconds) that the notification stays open for. */
  duration: _propTypes.default.number,

  /** Whether the notification should close itself without having to click the close button after the specified duration. */
  autoClose: _propTypes.default.bool,

  /** A function to execute after the notification has been hidden. Will receive the notification's props. */
  onHidden: _propTypes.default.func
};
var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = require('react-hot-loader').default;

  var leaveModule = require('react-hot-loader').leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(_default, "default", "/Users/mprzybylski/Work/SpotHero/fe-ui/src/Notification/NotificationPropTypes.js");
  leaveModule(module);
})();

;